import { Instance, types } from 'mobx-state-tree'

const Success = types.model('Success', {
  status: types.maybeNull(types.optional(types.string, '')),
})

export type SuccessType = Instance<typeof Success>
export { Success }
